import { Article, DianPurchaseItem } from '@shared-models';

import { ArticleMapper } from './article.mapper';

export class PurchaseItemMapper {
  /**
   * `quantity` is expressed in the unit the line was purchased in, so the unit
   * reported to DIAN has to match it. Unlike sales, purchases carry the unit
   * itself (`purchase_unit`), so there is nothing to resolve against the
   * article's packaging unit.
   *
   * Falls back to the article's base unit when the line has no purchase unit
   * (legacy rows) or that unit has no DIAN code — an empty unitCode would be
   * rejected by DIAN, and the base unit is the previous behaviour.
   */
  static mapper(purchaseItem: DianPurchaseItem) {
    const article = Array.isArray(purchaseItem.articulo)
      ? (purchaseItem.articulo[0] as Article)
      : (purchaseItem.articulo as Article);

    const mappedArticle = ArticleMapper.mapper(article);
    const purchaseUnit = purchaseItem.purchase_unit;

    return {
      ...purchaseItem,
      articulo: purchaseUnit?.dian_code
        ? {
            ...mappedArticle,
            unit: {
              description: purchaseUnit.description,
              dian_code: purchaseUnit.dian_code,
            },
          }
        : mappedArticle,
    };
  }
}
